import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import * as Semantic from 'semantic-ui-react'
import _ from 'lodash'

export default class DraggableItem extends React.PureComponent {
  state = { imageLoaded: false }

  componentWillReceiveProps(nextProps) {
    const { item } = this.props

    if (
      (item.itemData.images && item.itemData.images && item.itemData.images.thumb) !==
      (nextProps.item.itemData &&
        nextProps.item.itemData.images &&
        nextProps.item.itemData.images.thumb)
    ) {
      this.setState({ imageLoaded: false })
    }
  }

  render() {
    const { imageLoaded } = this.state

    const {
      item,
      index,
      saving,
      onDelete,
      onEdit,
      onUpload,
      showImage,
      itemTag,
      itemOptions,
      getItemDraggableStyle,
    } = this.props

    const sortedItemOptions = _.chain(item.itemData.options)
                               .map((option, key) => ({ ...option, key }))
                               .sortBy(option => option.order)
                               .value()

    const status = item.itemData.status === 'draft'
      ? { color: "red", text: 'Draft'}
      : { color: "green", text: 'Publish' }

    return (
      <Draggable key={item.id} draggableId={item.id} index={index} isDragDisabled={saving}>
        {(dragProvided, snapshot) => (
          <div>
            <div
              ref={dragProvided.innerRef}
              {...dragProvided.draggableProps}
              {...dragProvided.dragHandleProps}
              style={getItemDraggableStyle(snapshot.isDragging, dragProvided.draggableProps.style)}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                  flex: 1,
                  minHeight: showImage ? 73 : 36,
                }}
              >
                <div style={{ marginRight: 20 }}>
                  {item.order !== '' && (
                    <Semantic.Label color="red" horizontal>
                      {item.order}
                    </Semantic.Label>
                  )}
                </div>

                {showImage && (
                  <div style={{ marginRight: 20 }}>
                    {item.itemData.images && item.itemData.images.thumb ? (
                      <div style={{ width: 80, height: 80, position: 'relative' }}>
                        <Semantic.Image
                          src={item.itemData.images.thumb}
                          size="tiny"
                          rounded
                          verticalAlign="middle"
                          style={{ width: 80, height: 80 }}
                          onClick={onUpload}
                          onLoad={() => this.setState({ imageLoaded: true })}
                          loaded={imageLoaded}
                        />
                        {/* {!imageLoaded && (
                          <Semantic.Dimmer active>
                            <Semantic.Loader />
                          </Semantic.Dimmer>
                        )} */}
                      </div>
                    ) : (
                      <div style={{ width: 80, textAlign: 'center' }}>
                        <Semantic.Button size="mini" onClick={onUpload}>
                          Upload
                        </Semantic.Button>
                      </div>
                    )}
                  </div>
                )}

                <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                  <div>{item.itemData.name}</div>
                  <div style={{ color: 'gray', marginTop: 6 }}>
                    {item.itemData.description || 'No Description'}
                  </div>
                  <div style={{ marginTop: 6 }}>
                    {
                      _.map(sortedItemOptions, option => {
                        const optionKey = option.key
                        const itemOption = itemOptions[optionKey]

                        if (!itemOption) return null

                        const choices = _.map(option.choices, (choice, choiceKey) => ({
                          ...itemOption.choices[choiceKey],
                          price: choice.price
                        }))

                        return (
                          <Semantic.Popup
                            key={optionKey}
                            trigger={
                              <Semantic.Label color="blue">
                                {itemOption.name}
                              </Semantic.Label>
                            }
                          >
                            <Semantic.Label
                              size="small"
                              color={itemOption.is_required ? 'red' : 'green'}
                            >
                              {itemOption.is_required ? 'Required' : 'Optional'}
                            </Semantic.Label>
                            {
                              itemOption.is_multiple && (
                                <Semantic.Label size="small" color='orange'>
                                  Maximum: {itemOption.max_choice}
                                </Semantic.Label>
                              )
                            }
                            {
                              choices.map(choice => (
                                <p style={{ margin: '5px 0 0 0' }} key={choice.name}>
                                  {choice.name} : $ { parseFloat(choice.price).toFixed(2) }
                                </p>
                              ))
                            }
                          </Semantic.Popup>
                        )
                      })
                    }
                  </div>
                </div>
                <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                  {item.itemData.code ?
                    <Semantic.Label size="medium">
                    {item.itemData.code}
                    </Semantic.Label>
                  : null}
                </div>
                <div style={{ flex: 1, flexDirection: 'column', justifyContent: 'center' }}>
                  <Semantic.Label color={status.color} size="small">{status.text}ed</Semantic.Label>
                </div>
                <div style={{ flex: 1, flexDirection: 'column' }}>
                  <Semantic.Label size="medium">{itemTag()}</Semantic.Label>
                </div>

                <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                  <Semantic.Label color="orange" tag>{`$${parseFloat(
                    item.itemData.current_price
                  ).toFixed(2)}`}</Semantic.Label>
                </div>
                <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                  <Semantic.Button secondary size="tiny" onClick={onEdit} icon>
                    <Semantic.Icon name="edit" />
                    Edit
                  </Semantic.Button>
                  <Semantic.Button size="tiny" color="red" onClick={onDelete} icon>
                    <Semantic.Icon name="trash" />
                    Delete
                  </Semantic.Button>
                </div>
                <div style={{ marginLeft: 20 }}>
                  <Semantic.Icon name="align justify" />
                </div>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/views/draggableItem.js